module.exports = __webpack_public_path__ + "static/media/trump-face.6a2b78d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trump-face.png
// module id = 209
// module chunks = 0